import {WoolLabSwatchDetailModalBlock} from './woolLabSwatchDetailModalBlock';

const NS = 'WoolLabSwatchBlock';
const CLS = 'woolLabSwatchBlock';
const CLS_SAVED = 'woolLabSwatchBlock--saved';
import Handlebars from 'handlebars';

export class WoolLabSwatchBlock {
	constructor(el, data = {}) {
		this.el = el;
		this.$el = $(el);
		this.id = this.$el.data('id');
		this.email = this.$el.data('email');

		this.$id = this.$el.find(`.${CLS}-content-id`);
		this.$title = this.$el.find(`.${CLS}-content-title`);
		this.$imageWrap = this.$el.find(`.${CLS}-imageWrap`);
		this.$image = this.$el.find(`.${CLS}-image`);
		this.$btnWrap = this.$el.find(`.${CLS}-btnWrap`);
		this.$btnAddSave = this.$el.find(`.${CLS}-btnAddSave`);
		this.data = data;
		this.data.getSwatchDetailApi = this.$el.data('getSwatchDetailApi');
		this.data.getSupplierDetailApi = this.$el.data('getSupplierDetailApi');
        this.data.isInMySwatchesApi = this.$el.data('isInMySwatchesApi');
		this.fetchDetailsFromApi = this.$el.data('fetchDetailsFromApi');
		this.data.addToMySwatchesApi = this.$el.data('addToMySwatchesApi');
		this.data.getMoodboardsApi = this.$el.data('getMoodboardsApi');
		this.data.createMoodboardApi = this.$el.data('createMoodboardApi');
		this.data.addToMoodboardApi = this.$el.data('addToMoodboardApi');
		this.data.isLoggedIn = this.$el.data('isLoggedIn');
		this.data.isStudent = this.$el.data('isstudent');
		this.data.id = this.id;

		if (this.data.isLoggedIn === undefined) {
			this.data.isLoggedIn = true;
		}

		if (this.isSaved) {
			this.$el.addClass(CLS_SAVED);
		}

		if (this.fetchDetailsFromApi && this.data.getSwatchDetailApi && this.id) {
			this.getValues();
		}
		this.handleButtons();
	}

	handleButtons() {
		this.$el.on('click', (e) => {
			if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
				// mobile menu active
				if (this.$el.hasClass('touchActive')) {
					if ($(e.target).hasClass(`${CLS}-btnMobileDetail`)) {
						this.displayDetails();
					}
				}
				$(`.${CLS}`).addClass('touchDevice');
				$(`.${CLS}`).removeClass('touchActive');
				$(e.currentTarget).addClass('touchActive');
			} else {
				if (!$(e.target).hasClass(`${CLS}-btnAddSave`)) {
					this.displayDetails();
				}
			}
		});

		this.$el.on('mouseenter', (e) => {
			$(e.currentTarget).addClass('touchActive');
		});

		this.$el.on('mouseleave', (e) => {
			$(e.currentTarget).removeClass('touchActive');
		});
	}

	displayDetails() {
		$(document.body).append(this.getModalTemplate()(this.data));
		let $modal = $(`#woolLabSwatchDetailModalBlock--${this.data.id}`);
		if(this.$image.prop('naturalWidth') < this.$image.prop('naturalHeight')){
			$modal.addClass("portrait");
			var ratio = this.$image.prop('naturalHeight')/this.$image.prop('naturalWidth');
			var ratioStr = String(ratio).slice(0, 3);
			var ratioNum = Number(ratioStr);
		}
		if(this.$image.prop('naturalWidth') > this.$image.prop('naturalHeight')){
			$modal.addClass("landscape");
			var ratio = this.$image.prop('naturalWidth')/this.$image.prop('naturalHeight');
			var ratioStr = String(ratio).slice(0, 3);
			var ratioNum = Number(ratioStr);
		}
		$modal.attr('data-ratio', ratioNum);
		if(!this.data.isLoggedIn){
            $(`.woolLabSwatchDetailModalBlock-detailContainer-cta`).hide();
        }
		else{
			$(`.woolLabSwatchDetailModalBlock-detailContainer-cta`).show();
		}
		new WoolLabSwatchDetailModalBlock($modal[0], this.data);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
		});
	}

	getModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabSwatchDetailModalBlock.hbs');

		Handlebars.registerPartial('woolLabSwatchDetailModalBlock', modalWidget);

		let template = `
			{{> woolLabSwatchDetailModalBlock
				wg="woolLabSwatchDetailModalBlock"
				ns="WoolLabSwatchDetailModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	getValues() {
		fetch(`${this.data.getSwatchDetailApi}?swatchId=${encodeURIComponent(this.id)}`).then((response) => {
			return response.json();
		}).then((json) => {
			this.data = {
				...this.data,
				...json,
			};
			this.$title.html(this.data.name);
			this.$id.html(this.data.id);
			this.$image.attr('src', this.data.thumbnailImageSrc).attr('alt', this.data.name);
		});
	}
}


